import { AppStore } from 'stores/AppStore';

import VelieveLogo from '../Logos/VelieveLogo';
import DipUtiLogo from '../Logos/DipUtiLogo';

/**
 * @param {object} props
 */
function BrandLogo(props) {
  const BrandLogoComponent = AppStore.isDipUti ? DipUtiLogo : VelieveLogo;

  return <BrandLogoComponent {...props} />;
}

export default BrandLogo;
